import { NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';

import { SgKbMainRoutingModule } from './sg-kb-main-routing.module';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';
import { SharedModule } from 'cbc-shared-lib';
import { Sgkb701dComponent } from './pages/sgkb701d/pages/sgkb701d/sgkb701d.component';
import { Sgkb701dSearchConditionComponent } from './pages/sgkb701d/components/sgkb701d-search-condition/sgkb701d-search-condition.component';
import { Sgkb701dSearchResultComponent } from './pages/sgkb701d/components/sgkb701d-search-result/sgkb701d-search-result.component';
import { Sgkb708dComponent } from './pages/sgkb708d/pages/sgkb708d/sgkb708d.component';
import { Sgkb708dCtrinfoComponent } from './pages/sgkb708d/components/sgkb708d-ctrinfo/sgkb708d-ctrinfo.component';
import { Sgkb708dInclutagsupdemandctrComponent } from './pages/sgkb708d/components/sgkb708d-inclutagsupdemandctr/sgkb708d-inclutagsupdemandctr.component';
import { Sgkb708dAppliinfoComponent } from './pages/sgkb708d/components/sgkb708d-appliinfo/sgkb708d-appliinfo.component';
import { Sgkb708dButtonComponent } from './pages/sgkb708d/components/sgkb708d-button/sgkb708d-button.component';
import { Sgkb713dComponent } from './pages/sgkb713d/pages/sgkb713d/sgkb713d.component';
import { Sgkb713dSearchConditionComponent } from './pages/sgkb713d/components/sgkb713d-search-condition/sgkb713d-search-condition.component';
import { Sgkb713dSearchResultComponent } from './pages/sgkb713d/components/sgkb713d-search-result/sgkb713d-search-result.component';
import { Sgkb714dComponent } from './pages/sgkb714d/pages/sgkb714d/sgkb714d.component';
import { Sgkb714dBulksetComponent } from './pages/sgkb714d/components/sgkb714d-bulkset/sgkb714d-bulkset.component';
import { Sgkb980dComponent } from './pages/sgkb980d/pages/sgkb980d/sgkb980d.component';
import { Sgkb980dInputComponent } from './pages/sgkb980d/components/sgkb980d-input/sgkb980d-input.component';
import { Sgkb941dComponent } from './pages/sgkb941d/pages/sgkb941d/sgkb941d.component';
import { Sgkb941dWtContractChangeComponent } from './pages/sgkb941d/components/sgkb941d-wt-contract-change/sgkb941d-wt-contract-change.component';
import { Sgkb106dComponent } from './pages/sgkb106d/pages/sgkb106d/sgkb106d.component';
import { Sgkb106dImportantMatterComponent } from './pages/sgkb106d/components/sgkb106d-important-matter/sgkb106d-important-matter.component';
import { Sgkb122dComponent } from './pages/sgkb122d/pages/sgkb122d/sgkb122d.component';


@NgModule({
  declarations: [
    Sgkb701dComponent,
    Sgkb701dSearchConditionComponent,
    Sgkb701dSearchResultComponent,
    Sgkb708dComponent,
    Sgkb708dCtrinfoComponent,
    Sgkb708dInclutagsupdemandctrComponent,
    Sgkb708dAppliinfoComponent,
    Sgkb708dButtonComponent,
    Sgkb713dComponent,
    Sgkb713dSearchConditionComponent,
    Sgkb713dSearchResultComponent,
    Sgkb714dComponent,
    Sgkb714dBulksetComponent,
    Sgkb980dComponent,
    Sgkb980dInputComponent,
    Sgkb941dComponent,
    Sgkb941dWtContractChangeComponent,
    Sgkb106dComponent,
    Sgkb106dImportantMatterComponent,
    Sgkb122dComponent,
  ],
  imports: [
    SharedModule,
    SgKbMainRoutingModule,
    SgBaseSharedModule,
    QRCodeModule,
  ],
  exports: [
  ],
  providers: [
  ]
})
export class SgKbMainModule { }
